import { detectDeviceEnvironmentConstants, dispatcher, ingenuity, IObject } from "@quest/base-core";
import { FreeGameViewBehavior } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import { gameConstants } from "../Constants/gameConstants";

export class View extends FreeGameViewBehavior {
  public setReelMask(): void {
    this.mask = this.getShapeById("reelMaskFg");
  }
  /**
   * Method overrided
   */
  public setReelView(reelView: any, pos: any, parentId: any) {
    this.reelView = reelView;
    this.addChildAt(this.getSpineById("freeGameReelGlow"), 0);
    this.addChildAt(this.getImageById("reelBGFg"), 1);
    this.addChildAt(reelView, 3);
    const container = this.getContainerByID("reelsContainerFg");
    this.addChildAt(container, 4);
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.reelView.x = this.reelView.json.portraitX;
      this.reelView.y = this.reelView.json.portraitY;
    }
  }

   protected resizeOrientation(e?: IObject): void {
      super.resizeOrientation(e);
      if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT) {
        this.x = this.x + (gameConstants.ADD_IN_X * this.scale.x);
      }
          if(!ingenuity.deviceEnv.isDesktop){
      dispatcher.fireEvent(eventDispatchers.ALIGN_PROGRESS_BAR_FG);
    }
    }

  /**
   * overide to add win collection view on top
   */
  protected addButtonPanelOnTop(): void {
    super.addButtonPanelOnTop();
    dispatcher.fireEvent(eventDispatchers.ADD_LIGHTNING_VIEW_ON_TOP); //game event
    
    dispatcher.fireEvent(eventDispatchers.HANDLE_BUTTON_AS_PER_MARKET);
  }

  /**
   * to show all symbols alpha which are present on grid
   */
protected showAlpha(): void {
  if (this.reelView) {
    for (let reel = 0; reel < ingenuity.configData.numberOfReel; reel++) {
      for (let symbol = 0; symbol < 10; symbol++) {
        this.reelView.getSymbolByPos(reel, symbol).getStatic().tint = 0xffffff;
        const anim = this.reelView.getSymbolByPos(reel, symbol).getAnimation() as any;
        if (anim.name === "Note" || anim.name === "MagnifyingGlass" || anim.name === "Key" || anim.name === "Spotlight") {
          if (anim !== undefined) {
            anim.tint = 0xffffff;
          }
        }
      }
    }
  }
}
}
